<template>
    <span>
        <button
            type="button"
            class="btn btn-md is-primary"
            @click="$modal.show(`edit-email-alias-${emailAlias.id}`)"
        >
            {{ lang('Redigera','Edit') }}
        </button>

        <form-modal
            ::title="lang('Redigera vidarebefodring','Edit forwarding')"
            :name="`edit-email-alias-${emailAlias.id}`"
            method="patch"
            :primary-button-text="lang('Spara','Save')"
            :close-button-text="lang('Avbryt','Cancel')"
            :action="route('front.my-pages.api.email-aliases.update', emailAlias)"
            :redirect-to="route('front.my-pages.broadband.index')"
        >
            <text-input
                v-model="sendTo"
                :label="lang('Skicka till','Send to')"
                name="send_to"
                type="email"
                :required="true"
                validations="required|email"
            />

            <info-box>{{ lang('Du kan ange flera kommaseparerade e-postadresser','You can add several comma separated e-mail address') }}.</info-box>
        </form-modal>
    </span>
</template>

<script>
    export default {
        props: {
            emailAlias: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                sendTo: this.emailAlias.send_to,
            };
        },
    };
</script>
